    
    <app-compose-mail appendTo='body' style="z-index: 9999999;" ></app-compose-mail>

<p-table [columns]="cols" [value]="visiteurs"
selectionMode="single" [(selection)]="selectedBadge" 
#dt>
    <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix" style="text-align: left">
   



          

 
 



            <div style="float: right;">   
 

              

                <button mat-raised-button  style="background: rgb(223, 128, 4);margin-left: 5px; "  
                (click)="printBadge()">    <mat-icon class="mat-18" *ngIf="selectedBadge">print</mat-icon> Print Badge </button>
                <button mat-raised-button  style="background: #E0F2FD;margin-left: 5px;"  
                (click)="sendEBAdge(50)" *ngIf="selectedBadge">  <mat-icon class="mat-18">email</mat-icon>Send E-Badge EN </button>
                <button mat-raised-button  style="background: #E0F2FD;margin-left: 5px; "  
                (click)="sendEBAdge(51)" *ngIf="selectedBadge">  <mat-icon class="mat-18">email</mat-icon>Send E-Badge FR </button>

                <span *ngIf="dt.filteredValue"> {{dt.filteredValue.length}} / </span>{{dt.totalRecords}} Badges
                
                <button type="button" *ngIf="false"  pButton icon="pi pi-file" iconPos="left" label="CSV - Selection Only" (click)="dt.exportCSV({selectionOnly:true})"  ></button>
           
                <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                <input type="text" pInputText size="50" placeholder="Global Filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
            </div>
     
        </div>
       
 
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                {{col.header}}
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>

            </th>
        </tr>
        <tr >
            <th *ngFor="let col of columns"  [ngSwitch]="col.field">
     
                <input  style="border: none;"   pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')"> 
            </th>
        </tr>
       
        
        
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr  [pSelectableRow]="rowData">
            <td *ngFor="let col of columns"  [ngSwitch]="col.field">
                <span *ngSwitchCase="'dateImpression'"> {{rowData[col.field] | date }}</span> 
                <span *ngSwitchDefault> {{rowData[col.field]}}</span> 
                  
            </td>
        </tr>
    </ng-template>
</p-table>